/* eslint-disable prefer-promise-reject-errors */

export const makeReject = (error, values = {}) => {
  return values ? Promise.reject({ ...error, ...values }) : Promise.reject(error);
};
